import React, { useEffect, useState } from 'react';
import CrudTable from '../../components/common/CrudTable';
import { attendanceAPI, lessonAPI, enrolmentAPI } from '../../api/services';

const STATUS_OPTIONS = [
  { label: 'Present', value: 'PRESENT' },
  { label: 'Absent', value: 'ABSENT' },
  { label: 'Late', value: 'LATE' },
  { label: 'Excused', value: 'EXCUSED' },
];

const AttendancesAdmin = () => {
  const [lessons, setLessons] = useState([]);
  const [enrolments, setEnrolments] = useState([]);

  useEffect(() => {
    lessonAPI.getAll().then(res => setLessons(res.data?.data || [])).catch(() => {});
    enrolmentAPI.getAll().then(res => setEnrolments(res.data?.data || [])).catch(() => {});
  }, []);

  const getLessonLabel = (lesson) => {
    return `${lesson.groupName || 'Group'} - ${lesson.lessonDate} ${lesson.startTime || ''}`;
  };

  const getEnrolmentLabel = (enrolment) => {
    return `${enrolment.studentName || 'Student'} (${enrolment.groupName || 'Group'})`;
  };

  const COLUMNS = [
    { key: 'lessonDate', label: 'Lesson' },
    { key: 'studentName', label: 'Student' },
    { key: 'status', label: 'Status' },
    { key: 'note', label: 'Note' },
  ];

  const FORM_FIELDS = [
    { 
      name: 'lessonId', 
      label: 'Lesson', 
      type: 'select', 
      options: lessons.map(l => ({ label: getLessonLabel(l), value: l.id })) 
    },
    { 
      name: 'enrollmentId', 
      label: 'Student (Enrolment)', 
      type: 'select', 
      options: enrolments.map(e => ({ label: getEnrolmentLabel(e), value: e.id })) 
    },
    { 
      name: 'status', 
      label: 'Status', 
      type: 'select', 
      options: STATUS_OPTIONS 
    },
    { name: 'note', label: 'Note', type: 'textarea' },
  ];

  return (
    <CrudTable
      title="Attendances"
      entityName="Attendance"
      columns={COLUMNS}
      formFields={FORM_FIELDS}
      fetchData={async () => {
        const res = await attendanceAPI.getAll();
        return res.data?.data || [];
      }}
      onAdd={(data) => attendanceAPI.add(data)}
      onUpdate={(id, data) => attendanceAPI.update(id, data)}
      onDelete={(id) => attendanceAPI.delete(id)}
    />
  );
};

export default AttendancesAdmin;
